//@ts-nocheck
import { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html, PropertyValues } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/icons/jha-icon-filter";
import "@banno/jha-wc/src/icons/jha-icon-refresh";
import "@banno/jha-wc/src/icons/jha-icon-download";
import "@banno/jha-wc/src/collapsible-content/jha-collapsible-section/jha-collapsible-section";
import "@banno/jha-wc/src/forms/jha-form-date-input/jha-form-date-input";
import "@banno/jha-wc/src/forms/jha-form-checkbox/jha-form-checkbox";
import "@banno/jha-wc/src/icons/jha-icon-circle-checkmark-filled";
import "@banno/jha-wc/src/icons/jha-icon-circle-close-filled";
import "@banno/jha-wc/src/icons/jha-icon-information";
import {
  AuditDashboardRecords,
  AuditDashboardTableData,
} from "../../types/AuditDashboard/AuditDashboardType";
import { GlobalConstants, GlobalVariables } from "../../utils/constants";
import { Apis } from "../../utils/api-constants";
import "./AuditDetailsPage";
import { getRequest, postRequest } from "../../utils/jha-fetch";
import { getRoleData } from "../../utils/getRoleData";
import Cookies from "js-cookie";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { AppRouters } from "../../utils/app-router";
import "../../Components/Loader";
import { jhaDropdownMenuPanelStylesText } from "../../styles/jha-dropdown-menu-panel";
import "@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table";
import "@banno/jha-wc/src/jha-badge/jha-badge";
import "@banno/jha-wc/src/jha-tooltip/jha-tooltip";
import {
  getCurrentTimezone,
  stringComparison,
  getStatusToLowerCase,
  AUDIT_STATUS_BADGE_MAP,
  AUDIT_STATUS_FILTER_OPTIONS,
  renderStatusBadge,
  applyAuditReportingTableLayout,
  applyStatusColumnHeaderLayout,
  ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT,
  AUDIT_DASHBOARD_ELLIPSIS_TITLE_COLUMN_IDS,
  stripAdvancedTableRedundantTitles,
  STATUS_COLUMN_HEADER_ADVANCED_TABLE_STYLES_TEXT,
  decryptValue,
  getCurrentOffset,
  compareCurrentTimeWithStartEndDateTime,
  renderAdvancedTableEllipsisCell,
  buildAdvancedTableEllipsisColumnShadowCss,
  buildAdvancedTableJhaTooltipOverflowEscapeCss,
} from "../../utils/app-utils";
import {
  applyDurationColumnHeaderTooltip,
  buildCsvExportFilename,
  DURATION_COLUMN_LABEL,
  dateTimeColumnLabel,
  formatAuditTransDuration,
  formatDateTimeForDisplay,
  getAuditTransDurationEmptyLabel,
  renderTimezoneBanner,
} from "../../utils/datetime-display";
import {
  filterSelectBackspaceClearKeydown,
  pickerOnlyDateFieldKeydown,
} from "../../utils/filter-field-keyboard";
import { StatusConstants } from "../../utils/apiStatusConstants";
import { dateFormatter } from "../../utils/dateFormatter";
import { getBusinessUnitName } from "../../utils/getBusinessUnitName";
import {
  AUDIT_DASHBOARD_SESSION_RESTORE_FLAG_KEY,
  AUDIT_DASHBOARD_SESSION_SNAPSHOT_KEY,
  clearAuditDashboardSessionStorage,
  clearAuditDashboardSessionStorageOnRouteExit,
  isAuditReportingListPath,
  repairLegacyRemappedInitAuditPayload,
} from "../../utils/audit-dashboard-session-storage";

function readWorkflowIdFromLocationSearch(): string {
  if (typeof window === "undefined") return "";
  try {
    const raw = new URLSearchParams(window.location.search).get("workflowId");
    return raw == null ? "" : String(raw).trim();
  } catch {
    return "";
  }
}

const AUDIT_DASHBOARD_JHA_TOOLTIP_COLUMN_IDS = ["transDuration"] as const;

/** List snapshot must be refreshed (Apply filters / new search) after this age. */
const AUDIT_DASHBOARD_SNAPSHOT_MAX_AGE_MS = 5 * 60 * 1000;

function defaultAuditAdvancedTableConfig() {
  return {
    apiControlled: false,
    apiTotal: 0,
    sort: {
      columnId: "transStart",
      descending: true,
    },
  };
}

@customElement("audit-dashboard")
export class AuditDashboard extends routingMixin(LitElement) {
  static get is() {
    return "audit-dashboard";
  }
  constructor() {
    super();
  }
  static readonly styles = css`
    jha-icon-circle-checkmark-filled {
      fill: var(--jha-color-success);
    }
    jha-icon-circle-close-filled {
      fill: var(--jha-color-warning);
    }
    #formCon {
      display: flex;
      flex-direction: column;
    }
    #reportingDiv {
      display: flex;
      flex-direction: column;
      padding: 24px;
      gap: 15px;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
    jha-form-row {
      align-items: baseline;
      justify-content: flex-end;
      flex: 1;
    }
    jha-card {
      flex: 1;
      overflow: hidden;
      margin-left: 0px;
      margin-right: 0px;
      padding: 5px;
    }
    #filterBody {
      display: flex;
      flex-direction: column;
      padding-top: 10px;
      overflow: visible;
    }
    #filterId {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex: 1;
      overflow: visible;
    }
    #dateDiv {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      column-gap: 12px;
      row-gap: 12px;
      overflow: visible;
      width: 100%;
    }
    /* Dates are mm/dd/yyyy (10 chars) — don't steal width from Workflow Name */
    #dateDiv jha-form-date-input,
    .end-time-wrapper jha-form-date-input {
      width: 210px;
      flex: 0 0 210px;
    }
    #dateDiv jha-form-input,
    .end-time-wrapper jha-form-input {
      width: 160px;
      flex: 0 0 160px;
    }
    .filter-action-buttons {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      gap: 12px;
      margin-top: 33px;
    }
    .filter-action-buttons jha-tooltip {
      display: inline-flex;
      flex: 0 0 auto;
    }
    .filter-action-buttons jha-button {
      width: auto;
      min-width: fit-content;
    }
    jha-form-select {
      width: 220px;
      flex: 0 1 220px;
    }
    /* Prefer space for workflow id from deep-link / filters */
    #dateDiv jha-tooltip:has(jh-input#workflowId) {
      flex: 1 1 280px;
      min-width: 260px;
      max-width: 480px;
    }
    #dateDiv jha-tooltip:has(jh-input#workflowId) jh-input,
    #workflowId {
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    #dateDiv jha-tooltip:has(jh-input#traceId) {
      flex: 0 1 220px;
      min-width: 180px;
    }
    #traceId {
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    .table-container {
      display: flex;
      height: 100%;
    }
    .end-time-wrapper {
      position: relative;
      display: flex;
      gap: 12px;
      margin: 0;
      padding: 0;
      overflow: visible;
      flex: 0 0 auto;
    }
    .end-time-wrapper jha-form-input {
      width: 160px;
    }
    .end-time-wrapper jha-form-date-input {
      width: 180px;
    }
    .checkbox-now-container {
      position: absolute;
      top: 75px;
      left: 0;
      display: flex;
      align-items: center;
      gap: 0px;
      z-index: 10;
    }
    .checkbox-now-container label {
      margin-left: -8px;
    }
    .checkbox-now-container jha-tooltip {
      z-index: 10000;
      --jha-tooltip-max-width: 350px;
      --jha-tooltip-white-space: nowrap;
    }
    .checkbox-now-container jha-tooltip::part(tooltip) {
      white-space: nowrap !important;
      max-width: none !important;
      width: max-content !important;
    }
  `;
  @property({ type: Object })
  auditData: AuditDashboardTableData = {
    messageStatus: "",
    results: [],
    paging: 0,
    eTags: "",
  };
  @property({ type: Object })
  auditFetchedData: AuditDashboardTableData = {
    messageStatus: "",
    results: [],
    paging: 0,
    eTags: "",
  };
  /** Normalized rows for jha-advanced-table; rebuilt when auditData changes (not on sort). */
  @property({ type: Array })
  gridData: AuditDashboardRecords[] = [];
  @property()
  minDate: Date;
  @property()
  maxDate: Date;
  @property()
  filterTraceId = "";
  @property()
  startDate = this.formatDate(new Date());
  @property()
  startTime = "00:00";
  @property()
  endDate = this.formatDate(new Date());
  @property()
  endTime = this.getCurrentTime();
  @property({ type: Boolean })
  useCurrentTime = true;
  @property()
  loggedUserType = decryptValue(Cookies.get("userType"));
  @property()
  businessUnit = stringComparison(this.loggedUserType, "BusinessAdmin")
    ? Cookies.get("businessUnit")?.toLowerCase()
    : "";
  @property()
  filterWorkflowId = "";
  @property()
  filterStatus = "";
  @property({ type: Array })
  columns = [
    {
      label: "TRACE ID",
      id: "traceId",
    },
    {
      label: "WORKFLOW NAME",
      id: "workflowName",
      sortBy: true,
    },
    {
      label: "ACTIVATED BY",
      id: "activatedBy",
      sortBy: true,
    },
    {
      label: dateTimeColumnLabel("STARTED"),
      id: "transStart",
      sortBy: true,
      valueFormatter: (val) => formatDateTimeForDisplay(val),
    },
    {
      label: dateTimeColumnLabel("COMPLETED"),
      id: "transEnd",
      sortBy: true,
      valueFormatter: (val) => formatDateTimeForDisplay(val),
    },
    {
      label: DURATION_COLUMN_LABEL,
      id: "transDuration",
      sortBy: true,
      dataType: "number",
      valueRenderer: (val, row) => {
        const formatted = formatAuditTransDuration(val, row?.transTime);
        if (!formatted) {
          const inProgressLabel = getAuditTransDurationEmptyLabel(row?.status);
          if (inProgressLabel) {
            return html`<span>${inProgressLabel}</span>`;
          }
          const raw =
            val !== undefined && val !== null && val !== ""
              ? val
              : row?.transTime;
          if (raw === null || raw === undefined || raw === "") {
            return html`--`;
          }
          return html`<span>${String(raw)}</span>`;
        }
        return html`
          <jha-tooltip bottom text=${formatted.tooltip}>
            <span style="white-space: nowrap;">${formatted.display}</span>
          </jha-tooltip>
        `;
      },
    },
    {
      label: "STATUS",
      id: "status",
      sortBy: true,
      filters: [
        {
          label: "STATUS",
          id: "status",
        },
      ],
      dataType: "badge",
      badgeMap: [...AUDIT_STATUS_BADGE_MAP],
      valueRenderer: (val: string) => renderStatusBadge(val),
    },
    {
      label: "BUSINESS UNIT",
      id: "businessUnit",
      sortBy: true,
    },
    {
      label: "SOURCE PATH",
      id: "sourceFilePath",
      sortBy: true,
      valueRenderer: (val: string) => renderAdvancedTableEllipsisCell(val),
    },
    {
      label: "DESTINATION SERVER",
      id: "destinationFileServer",
      sortBy: true,
      valueRenderer: (val: string) => renderAdvancedTableEllipsisCell(val),
    },
  ].slice();
  @property()
  loading = false;
  @property()
  startDateTime = "";
  @property()
  endDateTime = "";
  @property({ type: Array })
  businessUnits = [];
  @property({ type: Object })
  advancedTableConfig = defaultAuditAdvancedTableConfig();
  @property({ type: Boolean })
  loadingMore = false;
  /**
   * Set before the first await in handleLoadMore. The grid moves to the next
   * page and can fire again before the page loader modal opens.
   */
  private auditPageFetchInFlight = false;
  /** True while building a large CSV so the UI can yield and show a loader. */
  @property({ type: Boolean })
  exportingCsv = false;
  @property()
  nextPageKey = "";
  @property()
  pageLimit = 100;
  @property()
  lastTraceId = "";
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  emptyAuditTable() {
    return {
      messageStatus: "",
      results: [],
      paging: 0,
      eTags: "",
    };
  }

  assignAuditData(tableData: AuditDashboardTableData) {
    const results = tableData?.results ?? [];
    this.auditData = { ...tableData, results };
    this.gridData = results;
  }
  getCurrentTime() {
    const date = new Date();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return hours + ":" + minutes;
  }
  logStartDateTime() {
    let startDateTime = "";
    if (this.startDate) {
      startDateTime += this.startDate;
      if (this.startTime) {
        startDateTime += " " + this.startTime;
      } else {
        startDateTime += " 00:00:00";
      }
    } else if (this.startTime) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      startDateTime = `${year}-${month}-${day} ${this.startTime}`;
    }
    startDateTime = startDateTime + " " + getCurrentOffset();
    return startDateTime;
  }

  logEndDateTime() {
    let endDateTime = "";
    if (this.endDate) {
      endDateTime += this.endDate;
      if (this.endTime) {
        endDateTime += " " + this.endTime;
      } else {
        endDateTime += " 23:59:59";
      }
    } else if (this.endTime) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      endDateTime = `${year}-${month}-${day} ${this.endTime}`;
    }
    endDateTime = endDateTime + " " + getCurrentOffset();
    return endDateTime;
  }

  onFiltersClickReset() {
    this.onSearchClear();
    this.startDate = this.formatDate(new Date());
    this.startTime = "00:00";
    this.endDate = this.formatDate(new Date());
    this.endTime = this.getCurrentTime();
    this.useCurrentTime = true;
    this.businessUnit = stringComparison(this.loggedUserType, "BusinessAdmin")
      ? this.businessUnit?.toLowerCase()
      : "";
    this.onWorkflowIdClear();
    this.filterStatus = "";
    this.clearPersistedAuditDashboardSnapshot();

    this.assignAuditData(this.emptyAuditTable());
    this.auditFetchedData = this.emptyAuditTable();
    this.nextPageKey = "";
    this.lastTraceId = "";
    this.startDateTime = "";
    this.endDateTime = "";
    this.advancedTableConfig = defaultAuditAdvancedTableConfig();
    this.loading = false;
    this.loadingMore = false;
    this.exportingCsv = false;
  }

  isValidTime(str) {
    let regex = new RegExp(/^ *([01]?\d|2[0-3]):([0-5]\d) *$/);

    if (!str) {
      return true;
    }

    if (regex.test(str) == true) {
      return true;
    } else {
      return false;
    }
  }

  get listData() {
    return this.gridData;
  }

  escapeCsvField(value) {
    if (value === null || value === undefined) {
      return "";
    }
    let s = String(value);
    // Neutralize spreadsheet formulas (CWE-1236): prefix and force-quote.
    if (/^[=+\-@\t\r]/.test(s)) {
      s = `'${s}`;
    }
    if (/[",\n\r]/.test(s) || s.startsWith("'")) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  }

  formatTransStartForExport(item: AuditDashboardRecords) {
    return formatDateTimeForDisplay(item.transStart);
  }

  formatTransEndForExport(item: AuditDashboardRecords) {
    return formatDateTimeForDisplay(item.transEnd);
  }

  /** Rows processed before yielding to the event loop (keeps UI responsive on large exports). */
  static readonly CSV_EXPORT_YIELD_ROW_INTERVAL = 400;

  /**
   * Cell text for CSV export, aligned with `columns` / visible table fields
   * (acceptance: same columns as the report results table).
   */
  getCellValueForCsvExport(
    item: AuditDashboardRecords,
    columnId: string
  ): string {
    switch (columnId) {
      case "traceId":
        return item.traceId ?? "";
      case "workflowName":
        return item.workflowName ?? "";
      case "activatedBy":
        return item.activatedBy ?? "";
      case "transStart":
        return String(this.formatTransStartForExport(item));
      case "transEnd":
        return String(this.formatTransEndForExport(item));
      case "transDuration": {
        const formatted = formatAuditTransDuration(
          item.transDuration,
          item.transTime,
        );
        if (!formatted) {
          const inProgressLabel = getAuditTransDurationEmptyLabel(item.status);
          if (inProgressLabel) {
            return inProgressLabel;
          }
          return "";
        }
        return formatted.display;
      }
      case "status":
        return item.status ?? "";
      case "businessUnit":
        return item.businessUnit ?? "";
      case "sourceFilePath":
        return item.sourceFilePath ?? "";
      case "destinationFileServer":
        return item.destinationFileServer ?? "";
      default: {
        const raw = (item as Record<string, unknown>)[columnId];
        if (raw === undefined || raw === null) {
          return "";
        }
        return String(raw);
      }
    }
  }

  auditRowToCsvLine(item: AuditDashboardRecords) {
    return this.columns
      .map((col) =>
        this.escapeCsvField(this.getCellValueForCsvExport(item, col.id))
      )
      .join(",");
  }

  /**
   * CSV export for Reporting (ACME reporting AC):
   * Rows = `listData` (current search/filter results, every page loaded via Load more).
   * Headers and cells follow `this.columns` so the file matches the visible table.
   * Filename: reporting-results_YYYY-MM-DD.csv · Success toast: "Results exported successfully".
   * Large exports yield every {@link AuditDashboard.CSV_EXPORT_YIELD_ROW_INTERVAL} rows.
   */
  async exportCurrentSearchResultsToCsv() {
    const rows = this.listData;
    if (!rows.length) {
      showToast({
        message:
          "There are no results to export for the current filters and search criteria.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
      return;
    }
    const headerLine = this.columns
      .map((col) => this.escapeCsvField(col.label))
      .join(",");
    const yieldEvery = AuditDashboard.CSV_EXPORT_YIELD_ROW_INTERVAL;

    this.exportingCsv = true;
    this.requestUpdate();

    try {
      const lines: string[] = [headerLine];
      for (let i = 0; i < rows.length; i++) {
        lines.push(this.auditRowToCsvLine(rows[i]));
        const processed = i + 1;
        if (
          processed % yieldEvery === 0 &&
          processed < rows.length
        ) {
          await new Promise<void>((resolve) => setTimeout(resolve, 0));
        }
      }
      const csvBody = lines.join("\r\n");
      const blob = new Blob(["\uFEFF", csvBody], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = buildCsvExportFilename("reporting-results");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      showToast({
        message: "Results exported successfully",
        role: "success",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } finally {
      this.exportingCsv = false;
      this.requestUpdate();
    }
  }

  tableClickRoute(evt) {
    this.persistAuditDashboardSnapshotToSession();
    const item = evt.detail.item;
    const traceId = item?.traceId;
    const path = `/audit-reporting/audit-details-page/${traceId}`;
    const wf = item?.workflowName;
    const workflowId = item?.workflowId;
    const bu = item?.businessUnit;
    const srv = item?.sourceFileServer;
    const activatedBy = item?.activatedBy;
    const idTrimmed = workflowId != null ? String(workflowId).trim() : "";
    const wfTrimmed = wf != null ? String(wf).trim() : "";
    const buTrimmed = bu != null ? String(bu).trim() : "";
    const srvTrimmed = srv != null ? String(srv).trim() : "";
    const activatedByTrimmed =
      activatedBy != null ? String(activatedBy).trim() : "";
    const params: Record<string, string> = {};
    if (idTrimmed) params.workflowId = idTrimmed;
    if (wfTrimmed) params.workflowName = wfTrimmed;
    if (buTrimmed) params.businessUnit = buTrimmed;
    if (srvTrimmed) params.sourceFileServer = srvTrimmed;
    if (activatedByTrimmed) params.activatedBy = activatedByTrimmed;
    AppRouters.go(path, Object.keys(params).length > 0 ? params : undefined);
  }

  clearPersistedAuditDashboardSnapshot() {
    clearAuditDashboardSessionStorage();
  }

  persistAuditDashboardSnapshotToSession() {
    try {
      if (typeof sessionStorage === "undefined") return;
      const payload = {
        savedAt: Date.now(),
        filterTraceId: this.filterTraceId,
        filterWorkflowId: this.filterWorkflowId,
        filterStatus: this.filterStatus,
        businessUnit: this.businessUnit,
        startDate: this.startDate,
        startTime: this.startTime,
        endDate: this.endDate,
        endTime: this.endTime,
        useCurrentTime: this.useCurrentTime,
        startDateTime: this.startDateTime,
        endDateTime: this.endDateTime,
        auditData: JSON.parse(JSON.stringify(this.auditData)),
        auditFetchedData: JSON.parse(JSON.stringify(this.auditFetchedData)),
        nextPageKey: this.nextPageKey,
        lastTraceId: this.lastTraceId,
        advancedTableConfig: JSON.parse(JSON.stringify(this.advancedTableConfig)),
      };
      sessionStorage.setItem(AUDIT_DASHBOARD_SESSION_SNAPSHOT_KEY, JSON.stringify(payload));
    } catch (e) {
      console.warn("Audit dashboard: could not persist list snapshot", e);
    }
  }

  restoreAuditDashboardSnapshotFromSession() {
    try {
      if (typeof sessionStorage === "undefined") return;
      const raw = sessionStorage.getItem(AUDIT_DASHBOARD_SESSION_SNAPSHOT_KEY);
      if (!raw) return;
      const p = JSON.parse(raw);
      const savedAt = typeof p.savedAt === "number" ? p.savedAt : 0;
      if (!savedAt || Date.now() - savedAt > AUDIT_DASHBOARD_SNAPSHOT_MAX_AGE_MS) {
        this.clearPersistedAuditDashboardSnapshot();
        return;
      }
      if (typeof p.filterTraceId === "string") this.filterTraceId = p.filterTraceId;
      if (typeof p.filterWorkflowId === "string") this.filterWorkflowId = p.filterWorkflowId;
      if (typeof p.filterStatus === "string") this.filterStatus = p.filterStatus;
      if (typeof p.businessUnit === "string") this.businessUnit = p.businessUnit;
      if (typeof p.startDate === "string") this.startDate = p.startDate;
      if (typeof p.startTime === "string") this.startTime = p.startTime;
      if (typeof p.endDate === "string") this.endDate = p.endDate;
      if (typeof p.endTime === "string") this.endTime = p.endTime;
      if (typeof p.useCurrentTime === "boolean") this.useCurrentTime = p.useCurrentTime;
      if (typeof p.startDateTime === "string") this.startDateTime = p.startDateTime;
      if (typeof p.endDateTime === "string") this.endDateTime = p.endDateTime;
      if (p.auditData && typeof p.auditData === "object") {
        this.assignAuditData(repairLegacyRemappedInitAuditPayload(p.auditData));
      }
      if (p.auditFetchedData && typeof p.auditFetchedData === "object") {
        this.auditFetchedData = repairLegacyRemappedInitAuditPayload(
          p.auditFetchedData,
        );
      }
      if (typeof p.nextPageKey === "string") this.nextPageKey = p.nextPageKey;
      if (typeof p.lastTraceId === "string") this.lastTraceId = p.lastTraceId;
      if (p.advancedTableConfig && typeof p.advancedTableConfig === "object") {
        this.advancedTableConfig = {
          ...defaultAuditAdvancedTableConfig(),
          ...p.advancedTableConfig,
          apiControlled: false,
        };
      }
      this.loading = false;
      this.loadingMore = false;
      this.requestUpdate();
    } catch (e) {
      console.warn("Audit dashboard: could not restore list snapshot", e);
    }
  }

  async routeEnter(currentNode, nextNodeIfExists, routeId, context) {
    await super.routeEnter(currentNode, nextNodeIfExists, routeId, context);
    try {
      if (!nextNodeIfExists && typeof sessionStorage !== "undefined") {
        if (sessionStorage.getItem(AUDIT_DASHBOARD_SESSION_RESTORE_FLAG_KEY) === "1") {
          sessionStorage.removeItem(AUDIT_DASHBOARD_SESSION_RESTORE_FLAG_KEY);
          this.restoreAuditDashboardSnapshotFromSession();
        }
      }
    } catch (e) {
      console.warn("Audit dashboard: session restore skipped", e);
    }
  }

  async routeExit(currentNode, nextNode, routeId, context) {
    clearAuditDashboardSessionStorageOnRouteExit(context);
    await super.routeExit(currentNode, nextNode, routeId, context);
  }

  async onFiltersClick() {
    this.startDate =
      this.startDate === "" ? this.formatDate(new Date()) : this.startDate;
    this.endDate =
      this.endDate === "" ? this.formatDate(new Date()) : this.endDate;
    this.startTime = this.startTime === "" ? "00:00" : this.startTime;
    // If "Now" checkbox is checked, update end date and time to current values
    if (this.useCurrentTime) {
      this.endDate = this.formatDate(new Date());
      this.endTime = this.getCurrentTime();
      this.requestUpdate();
    }
    this.endTime = this.endTime === "" ? "00:00" : this.endTime;
    this.startDateTime = this.logStartDateTime();
    this.endDateTime = this.logEndDateTime();

    this.assignAuditData(this.emptyAuditTable());
    this.nextPageKey = "";
    this.lastTraceId = "";
    this.loading = true;
    try {
      if (!this.isValidTime(this.startTime)) {
        showToast({
          message: "Invalid Time Format: StartTime",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
        return;
      }
      if (!this.isValidTime(this.endTime)) {
        showToast({
          message: "Invalid Time Format: EndTime",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
        return;
      }
      const valMsg = compareCurrentTimeWithStartEndDateTime(
        new Date(this.startDateTime),
        new Date(this.endDateTime),
        getCurrentTimezone()
      );
      if (valMsg != "") {
        showToast({
          message: valMsg,
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
        return;
      }
      const res = await this.requestAuditSearchPage();
      if (!res) {
        return;
      }
      if (res?.status === StatusConstants.UNAUTHORIZED_USER_CODE) {
        this.assignAuditData(this.emptyAuditTable());
        showToast({
          message: "Access Denied.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      } else if (res?.messageStatus === null) {
        const normalized = getStatusToLowerCase(res) ?? res;
        this.assignAuditData(normalized);
        this.auditFetchedData = normalized;
        this.nextPageKey = normalized.pageKey ?? "";
        this.lastTraceId = normalized.results?.at(-1)?.traceId ?? "";
        this.advancedTableConfig = {
          ...this.advancedTableConfig,
          apiControlled: false,
          apiTotal: normalized.totalCount ?? this.gridData.length,
          sort: {
            columnId: "transStart",
            descending: true,
          },
        };
        this.persistAuditDashboardSnapshotToSession();
      } else if (res?.status === StatusConstants.NOT_FOUND_USER_CODE) {
        this.assignAuditData(this.emptyAuditTable());
      } else if (res?.details?.length > 0) {
        const errMsg = getErrorMessage(res.details);
        showToast({
          message: errMsg,
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      } else {
        showToast({
          message: "Something went wrong, please try again.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      }
    } catch {
      showToast({
        message: "Something went wrong, please try again.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } finally {
      this.loading = false;
    }
  }

  @property()
  pageTitle = "Reporting";

  async connectedCallback() {
    super.connectedCallback();
    document.title = GlobalVariables.MAIN_TITLE?.concat(" >", this.pageTitle);

    // Ensure current time is set if checkbox is checked by default
    if (this.useCurrentTime) {
      this.endTime = this.getCurrentTime();
      this.endDate = this.formatDate(new Date());
    }

    const businessUnitsAllRes = await getRequest(
      Apis.GET_ALL_BUSINESSUNITVALUES
    );
    const businessUnitsRes = businessUnitsAllRes?.businessUnitValues ?? [];
    this.businessUnits = businessUnitsRes
      .filter(
        (bu) =>
          bu.status === "active" ||
          bu.name.toLowerCase() === this.businessUnit?.toLocaleLowerCase()
      )
      .map((y) => {
        return { value: y.value, name: y.name };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
    var imputDate = new Date();
    this.minDate = dateFormatter(imputDate, {
      days: 1,
      months: -GlobalConstants.CALANDER_MIN_DATE_MONTHS,
    });
    this.maxDate = dateFormatter(imputDate, {
      days: GlobalConstants.CALANDER_MAX_DATE_DAYS,
    });

    const incomingWorkflowId = readWorkflowIdFromLocationSearch();
    if (incomingWorkflowId && isAuditReportingListPath(window.location.pathname)) {
      clearAuditDashboardSessionStorage();
      this.filterWorkflowId = incomingWorkflowId;
      this.startDate = this.formatDate(new Date());
      this.startTime = "00:00";
      try {
        window.history.replaceState({}, "", "/audit-reporting");
      } catch {
        /* noop */
      }
      await this.onFiltersClick();
    }
  }

  private readTimeInputValueFromEvent(e: KeyboardEvent, autoId: string): string | undefined {
    const host = e.composedPath().find(
      (n): n is HTMLElement =>
        n instanceof HTMLElement && n.getAttribute("data-auto-id") === autoId,
    );
    if (!host) {
      return undefined;
    }
    const v = (host as unknown as { value?: string }).value;
    return typeof v === "string" ? v : undefined;
  }

  private commitAuditFilterEnterKey(e: KeyboardEvent, timeField?: "startTime" | "endTime") {
    if (e.key !== "Enter") {
      return;
    }
    e.preventDefault();
    if (timeField === "startTime") {
      const v = this.readTimeInputValueFromEvent(e, "startTimeInput");
      if (v !== undefined) {
        this.startTime = v;
      }
    } else if (timeField === "endTime") {
      const v = this.readTimeInputValueFromEvent(e, "endTimeInput");
      if (v !== undefined) {
        this.endTime = v;
      }
    }
    void this.onFiltersClick();
  }

  onAuditFilterFieldKeyDown(e: KeyboardEvent) {
    this.commitAuditFilterEnterKey(e);
  }

  onAuditStartTimeFilterKeyDown(e: KeyboardEvent) {
    this.commitAuditFilterEnterKey(e, "startTime");
  }

  onAuditEndTimeFilterKeyDown(e: KeyboardEvent) {
    this.commitAuditFilterEnterKey(e, "endTime");
  }

  onAuditDateFieldKeydown(e: KeyboardEvent) {
    pickerOnlyDateFieldKeydown(e);
  }

  onTraceIDChange(e: { target: { value: string } }) {
    this.filterTraceId = e.target.value;
  }
  onWorkflowIdChange(e: { target: { value: string } }) {
    this.filterWorkflowId = e.target.value;
  }
  onSearchClear() {
    this.filterTraceId = "";
  }
  onWorkflowIdClear() {
    this.filterWorkflowId = "";
  }
  onStartDateChange(e: { target: { value: string } }) {
    this.startDate = e.target.value;
  }
  onStartDateTimeChange(e: { target: { value: string } }) {
    this.startTime = e.target.value;
  }
  onEndDateChange(e: { target: { value: string } }) {
    this.endDate = e.target.value;
    const currentDate = this.formatDate(new Date());
    if (this.endDate !== currentDate) {
      this.useCurrentTime = false;
      this.endTime = "00:00";
    }
  }
  onEndDateTimeChange(e: { target: { value: string } }) {
    this.endTime = e.target.value;
  }
  onUseCurrentTimeChange(e: { target: { checked: boolean } }) {
    this.useCurrentTime = e.target.checked;
    if (this.useCurrentTime) {
      this.endTime = this.getCurrentTime();
      this.endDate = this.formatDate(new Date());
    } else {
      this.endTime = "00:00";
    }
  }
  onBusinessUnitChange(e: { target: { value: string } }) {
    this.businessUnit = e.target.value;
  }

  onStatusChange(e: { target: { value: string } }) {
    this.filterStatus = e.target.value;
  }

  onAuditBusinessUnitSelectKeydown(e: KeyboardEvent) {
    filterSelectBackspaceClearKeydown(e, {
      value: this.businessUnit,
      locked: stringComparison(this.loggedUserType, "BusinessAdmin"),
      onClear: () => this.onBusinessUnitChange({ target: { value: "" } }),
    });
  }
  buildAuditSearchBody() {
    return {
      traceId: this.filterTraceId.trim() ?? "",
      businessUnit: this.businessUnit ?? "",
      logStartDateTime: this.startDateTime,
      logEndDateTime: this.endDateTime,
      workflowId: this.filterWorkflowId.trim() ?? "",
      status: this.filterStatus ?? "",
    };
  }

  async requestAuditSearchPage(pageKey = "", lastTraceId = "") {
    const url = pageKey
      ? `${Apis.AUDIT_SEARCH}?lastTraceId=${lastTraceId}&pageKey=${pageKey}`
      : Apis.AUDIT_SEARCH;
    return postRequest(url, this.buildAuditSearchBody());
  }

  async fetchNextPageData(): Promise<boolean> {
    this.loadingMore = true;
    try {
      const res = await this.requestAuditSearchPage(
        this.nextPageKey,
        this.lastTraceId,
      );
      if (!res) {
        return false;
      }
      if (res?.messageStatus === null) {
        this.auditFetchedData = getStatusToLowerCase(res);
        this.nextPageKey = res.pageKey ?? "";
        this.lastTraceId = this.auditFetchedData?.results?.at(-1)?.traceId ?? "";
        return true;
      }
      if (res?.details?.length > 0) {
        const errMsg = getErrorMessage(res.details);
        showToast({
          message: errMsg,
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      } else {
        showToast({
          message: "Something went wrong, please try again.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      }
      return false;
    } finally {
      this.loadingMore = false;
    }
  }

  /**
   * jha-advanced-table changes pageOffset before it emits pagination-forward
   * or pagination-backward. Put that step back when this click must not stick.
   */
  private stepReportingTablePage(delta: number) {
    const root = this.renderRoot;
    if (!root || typeof root.querySelector !== "function") {
      return;
    }
    const table = root.querySelector("jha-advanced-table") as {
      pageOffset?: number;
    } | null;
    if (!table || typeof table.pageOffset !== "number") {
      return;
    }
    const next = table.pageOffset + delta;
    if (next < 0) {
      return;
    }
    table.pageOffset = next;
  }

  /** Previous is local to the grid; undo it while a next-page request is open. */
  private holdReportingPageWhileLoading() {
    if (!this.auditPageFetchInFlight) {
      return;
    }
    this.stepReportingTablePage(1);
  }

  /** @returns true when at least one new run was appended. */
  private mergeUniqueAuditPage(): boolean {
    const page = this.auditFetchedData;
    const incoming = page?.results ?? [];
    if (!incoming.length) {
      return false;
    }
    const seen = new Set(
      (this.auditData.results ?? [])
        .map((row) => (row?.traceId ?? "").toString().trim())
        .filter((id) => id.length > 0),
    );
    const fresh = incoming.filter((row) => {
      const id = (row?.traceId ?? "").toString().trim();
      if (!id) {
        return true;
      }
      if (seen.has(id)) {
        return false;
      }
      seen.add(id);
      return true;
    });
    if (!fresh.length) {
      return false;
    }
    const merged: AuditDashboardTableData = {
      ...this.auditData,
      results: [...(this.auditData.results ?? []), ...fresh],
      pageKey: page.pageKey,
      totalCount: page.totalCount ?? this.auditData.totalCount,
    };
    this.assignAuditData(merged);
    this.advancedTableConfig = {
      ...this.advancedTableConfig,
      apiTotal: merged.totalCount ?? this.gridData.length,
    };
    return true;
  }

  async handleLoadMore() {
    if (this.auditPageFetchInFlight) {
      this.stepReportingTablePage(-1);
      return;
    }
    if (this.nextPageKey === "") {
      this.stepReportingTablePage(-1);
      return;
    }
    this.auditPageFetchInFlight = true;
    let added = false;
    try {
      const ok = await this.fetchNextPageData();
      if (ok) {
        added = this.mergeUniqueAuditPage();
        this.persistAuditDashboardSnapshotToSession();
      }
    } finally {
      this.auditPageFetchInFlight = false;
    }
    if (!added) {
      this.stepReportingTablePage(-1);
    }
  }

  renderTable() {
    return html`
      <div class="table-container">
        <jha-advanced-table
          style="--jha-table-header-transform: uppercase;"
          .tableConfig=${this.advancedTableConfig}
          .columns=${this.columns}
          .fullWidthColumns=${true}
          .data=${this.gridData}
          .loading=${this.loading}
          .noContentMessage=${"No Data to Display"}
          @pagination-forward=${this.handleLoadMore}
          @pagination-backward=${this.holdReportingPageWhileLoading}
          @table-cell-click=${this.tableClickRoute}
          @table-update=${this.handleTableUpdate}
          .loadingMore=${this.loadingMore}
          .pageLimit=${this.pageLimit}
          .apiHasMoreData=${this.nextPageKey !== ""}
        ></jha-advanced-table>
      </div>
    `;
  }

  updated(changed: PropertyValues) {
    super.updated?.(changed);
    const table = this.renderRoot.querySelector(
      "jha-advanced-table"
    ) as HTMLElement | null;
    if (table) {
      table.toggleAttribute(
        "data-api-loading",
        this.loading || this.loadingMore || this.exportingCsv
      );
      table.toggleAttribute(
        "data-has-data",
        this.gridData.length > 0
      );
    }
    if (
      changed.has("auditData") ||
      changed.has("gridData") ||
      changed.has("loading") ||
      changed.has("columns")
    ) {
      requestAnimationFrame(() => this.injectAdvancedTableStyles());
    }
  }

  private handleTableUpdate(event: CustomEvent) {
    if (event.detail?.type === "sort") {
      // ponytail: grid owns sort; skip parent re-render and full shadow-DOM style pass
      requestAnimationFrame(() => this.applySortHeaderStylesOnly());
      return;
    }
    requestAnimationFrame(() => this.injectAdvancedTableStyles());
  }

  private applySortHeaderStylesOnly() {
    const table = this.renderRoot.querySelector(
      "jha-advanced-table"
    ) as HTMLElement | null;
    applyStatusColumnHeaderLayout(table?.shadowRoot);
  }

  private injectAdvancedTableStyles() {
    const table = this.renderRoot.querySelector(
      "jha-advanced-table"
    ) as HTMLElement | null;
    const root = table?.shadowRoot;
    if (!root) return;
    const css = `
        ${ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT}
        ${STATUS_COLUMN_HEADER_ADVANCED_TABLE_STYLES_TEXT}
        ${jhaDropdownMenuPanelStylesText}
        .loading jh-progress { visibility: hidden; }
        :host([data-api-loading]) .no-content,
        :host([data-has-data]) .no-content { visibility: hidden; }
        .no-content p {
            font-size: 20px;
            font-weight: 600;
            margin: 0;
        }
        ${buildAdvancedTableEllipsisColumnShadowCss([
      "sourceFilePath",
      "destinationFileServer",
    ])}
        ${buildAdvancedTableJhaTooltipOverflowEscapeCss(AUDIT_DASHBOARD_JHA_TOOLTIP_COLUMN_IDS)}
    `;
    let style = root.querySelector("style[data-acme-1180]") as HTMLStyleElement | null;
    if (!style) {
      style = document.createElement("style");
      style.setAttribute("data-acme-1180", "");
      root.appendChild(style);
    }
    style.textContent = css;
    applyAuditReportingTableLayout(root);
    stripAdvancedTableRedundantTitles(root, AUDIT_DASHBOARD_ELLIPSIS_TITLE_COLUMN_IDS);
    applyDurationColumnHeaderTooltip(root);
  }

  render() {
    return html`
      <slot>
        ${this.loading || this.loadingMore || this.exportingCsv
        ? html`<circle-loader></circle-loader>`
        : undefined}
        <div id="reportingDiv">
          <div id="formCon">
            <h1>Reporting</h1>
            ${renderTimezoneBanner(undefined, "padding-bottom:8px;")}
            <jha-collapsible-section is-open>
              <div slot="header">Filters</div>
              <div slot="body" id="filterBody">
                <div id="filterId">
                  <div id="dateDiv">
                    ${getCurrentTimezone().includes(GlobalConstants.TIMEZONE)
        ? html`
                          <jha-form-date-input
                            data-auto-id="startDateAsiaInput"
                            min=${this.minDate}
                            max=${this.maxDate}
                            warning="Invalid date"
                            @keydown=${this.onAuditDateFieldKeydown}
                            id
                            type="date"
                            minlength="0"
                            maxlength="10"
                            role="textbox"
                            outline
                            label="START DATE"
                            .value=${this.startDate}
                            @change=${this.onStartDateChange}
                          ></jha-form-date-input>
                        `
        : html`
                          <jha-tooltip bottom text="Select start date.">
                            <jha-form-date-input
                              data-auto-id="startDateInput"
                              min=${this.minDate}
                              max=${this.maxDate}
                              warning="Invalid date"
                              @keydown=${this.onAuditDateFieldKeydown}
                              id
                              type="date"
                              minlength="0"
                              maxlength="10"
                              role="textbox"
                              outline
                              label="START DATE"
                              .value=${this.startDate}
                              @change=${this.onStartDateChange}
                            ></jha-form-date-input>
                          </jha-tooltip>
                        `}
                    <jha-tooltip
                      bottom
                      text="Enter start time. Format: HH:MM (Military Time)."
                    >
                      <jha-form-input
                        data-auto-id="startTimeInput"
                        outline
                        placeholder="hh:mm"
                        label=${`${dateTimeColumnLabel("START TIME")} hh:mm`}
                        pattern="^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$"
                        warning="Invalid/Blank time"
                        .value=${this.startTime}
                        @change=${this.onStartDateTimeChange}
                        @keydown=${this.onAuditStartTimeFilterKeyDown}
                      ></jha-form-input>
                    </jha-tooltip>

                    <div class="end-time-wrapper">
                      <div class="checkbox-now-container">
                        <jha-tooltip
                          bottom
                          text="Select Now to use current date/time as end date/time."
                        >
                          <jha-form-checkbox
                            data-auto-id="useCurrentTimeCheckbox"
                            .checked=${this.useCurrentTime}
                            @change=${this.onUseCurrentTimeChange}
                          ></jha-form-checkbox>
                        </jha-tooltip>
                        <label style="font-size: 12px; margin: 0;">Now</label>
                      </div>
                      ${getCurrentTimezone().includes(GlobalConstants.TIMEZONE)
        ? html`
                            <jha-form-date-input
                              data-auto-id="endDateAsiaInput"
                              min=${this.minDate}
                              max=${this.maxDate}
                              warning="Invalid date"
                              @keydown=${this.onAuditDateFieldKeydown}
                              outline
                              type="date"
                              minlength="0"
                              maxlength="10"
                              role="textbox"
                              label="END DATE"
                              .value=${this.endDate}
                              @change=${this.onEndDateChange}
                              ?disabled=${this.useCurrentTime}
                            ></jha-form-date-input>
                          `
        : html`
                            <jha-tooltip bottom text="Select end date.">
                              <jha-form-date-input
                                data-auto-id="endDateInput"
                                min=${this.minDate}
                                max=${this.maxDate}
                                warning="Invalid date"
                                @keydown=${this.onAuditDateFieldKeydown}
                                outline
                                type="date"
                                minlength="0"
                                maxlength="10"
                                role="textbox"
                                label="END DATE"
                                .value=${this.endDate}
                                @change=${this.onEndDateChange}
                                ?disabled=${this.useCurrentTime}
                              ></jha-form-date-input>
                            </jha-tooltip>
                          `}
                      <jha-tooltip
                        bottom
                        text="Enter end time. Format: HH:MM (Military Time)."
                      >
                        <jha-form-input
                          data-auto-id="endTimeInput"
                          outline
                          placeholder="hh:mm"
                          pattern="^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$"
                          warning="Invalid/Blank time"
                          label=${`${dateTimeColumnLabel("END TIME")} hh:mm`}
                          .value=${this.endTime}
                          @change=${this.onEndDateTimeChange}
                          @keydown=${this.onAuditEndTimeFilterKeyDown}
                          ?disabled=${this.useCurrentTime}
                        ></jha-form-input>
                      </jha-tooltip>
                    </div>
                    <jha-tooltip
                      bottom
                      text="Select Business Unit. When focused, press Backspace to clear the selection."
                    >
                      <jha-form-select
                        outline
                        label="Business Unit"
                        .options=${this.businessUnits}
                        lableKey="name"
                        valueKey="value"
                        data-id="businessUnit"
                        data-auto-id="businessUnitSelect"
                        emptyOptionLabel="Select Business Unit"
                        .value=${this.businessUnit}
                        @change=${this.onBusinessUnitChange}
                        @keydown=${this.onAuditBusinessUnitSelectKeydown}
                        ?disabled=${stringComparison(
          this.loggedUserType,
          "BusinessAdmin"
        )}
                      ></jha-form-select>
                    </jha-tooltip>
                    <jha-tooltip
                      bottom
                      text="Select a record status. When focused, press Backspace to clear the selection."
                    >
                      <jha-form-select
                        outline
                        label="Status"
                        .options=${AUDIT_STATUS_FILTER_OPTIONS}
                        lableKey="name"
                        valueKey="value"
                        data-auto-id="statusSelect"
                        emptyOptionLabel="All"
                        .value=${this.filterStatus}
                        @change=${this.onStatusChange}
                        @keydown=${(e: KeyboardEvent) =>
        filterSelectBackspaceClearKeydown(e, {
          value: this.filterStatus,
          onClear: () => this.onStatusChange({ target: { value: "" } }),
        })}
                      ></jha-form-select>
                    </jha-tooltip>
                    <jha-tooltip
                      bottom
                      text="Enter Workflow ID to filter by workflow."
                    >
                      <jh-input
                        data-auto-id="workflowIdInput"
                        outline
                        id="workflowId"
                        label="Workflow ID"
                        .value=${this.filterWorkflowId}
                        placeholder="Enter Workflow ID"
                        show-clear-button="true"
                        @keydown=${this.onAuditFilterFieldKeyDown}
                        @jh-change=${this.onWorkflowIdChange}
                        @jh-clear=${this.onWorkflowIdClear}
                        maxlength="256"
                      ></jh-input>
                    </jha-tooltip>
                    <jha-tooltip
                      bottom
                      text="Enter Trace ID to filter by trace id only."
                    >
                      <jh-input
                        data-auto-id="traceIdInput"
                        outline
                        id="traceId"
                        label="Trace ID"
                        .value=${this.filterTraceId}
                        placeholder="Enter Trace ID"
                        show-clear-button="true"
                        @keydown=${this.onAuditFilterFieldKeyDown}
                        @jh-change=${this.onTraceIDChange}
                        @jh-clear=${this.onSearchClear}
                        maxlength="256"
                      ></jh-input>
                    </jha-tooltip>
                  </div>
                </div>
                <div class="filter-action-buttons">
                  <jha-tooltip
                    top-right
                    text="Click Apply Filters to filter on selected criteria."
                  >
                    <jha-button
                      data-auto-id="applyFiltersBtn"
                      type="button"
                      primary
                      large
                      sync
                      @click=${this.onFiltersClick}
                      ><jha-icon-filter slot="icon-left"></jha-icon-filter>Apply
                      Filters</jha-button
                    >
                  </jha-tooltip>
                  <jha-tooltip
                    top-right
                    text="Click Reset Filters to clear all filters."
                  >
                    <jha-button
                      data-auto-id="resetFiltersBtn"
                      type="button"
                      primary
                      large
                      sync
                      @click=${this.onFiltersClickReset}
                      ><jha-icon-refresh slot="icon-left"></jha-icon-refresh
                      >Reset Filters</jha-button
                    >
                  </jha-tooltip>
                  <jha-tooltip
                    top-right
                    text="Exports only the records currently shown in the table based on your filters and search criteria. Columns match the results table; rows include any pages loaded with Load more. Large exports run in the background so the page stays responsive."
                  >
                    <jha-button
                      data-auto-id="exportCurrentSearchResultsCsvBtn"
                      type="button"
                      primary
                      large
                      sync
                      ?disabled=${this.loading ||
      this.exportingCsv ||
      this.listData.length === 0}
                      @click=${() => void this.exportCurrentSearchResultsToCsv()}
                      ><jha-icon-download
                        slot="icon-left"
                      ></jha-icon-download
                      >Export Current View</jha-button
                    >
                  </jha-tooltip>
                </div>
              </div>
            </jha-collapsible-section>
          </div>
          <jha-card>${this.renderTable()}</jha-card>
        </div>
      </slot>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "audit-dashboard": AuditDashboard;
  }
}
